import React, { FC, useEffect, useState } from 'react'
import { useTheme } from '@config/theme.config'

const getCountdown = (selectedDay: string, hourString: string) => {
  const targetHour = parseInt(hourString, 10)
  const now = new Date()
  const targetTime = new Date(selectedDay) // Using string to create a Date
  targetTime.setHours(targetHour, 0, 0, 0)

  if (now > targetTime || selectedDay == '' || hourString == '') {
    return '00:00'
  }

  const diffMs = targetTime.getTime() - now.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const hours = Math.floor(diffMins / 60)
    .toString()
    .padStart(2, '0')
  const mins = (diffMins % 60).toString().padStart(2, '0')

  return `${hours}:${mins}`
}

const ClockComponent: FC<{ selectedDay: string; selectedHour: string }> = ({
  selectedDay,
  selectedHour,
}) => {
  const { theme } = useTheme()
  const [time, setTime] = useState(getCountdown(selectedDay, selectedHour))

  useEffect(() => {
    const timer = setInterval(
      () => setTime(getCountdown(selectedDay, selectedHour)),
      60000
    )
    return () => clearInterval(timer)
  }, [selectedDay, selectedHour])

  return (
    <span
      className={`rounded-2 bg-dark-subtle text-bg-${theme} px-3 py-2`}
      style={{ lineHeight: '20px', fontSize: '20px', fontWeight: '700' }}
    >
      {time}
    </span>
  )
}

export default ClockComponent
